export const liteLockGroupCss = {
  display: "flex",
  width: "100px",
  justifyContent: "space-between",
  alignItems: "center",
};
